import { LocalStorageService } from './../_services/local-storage.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-firstlogin',
    templateUrl: './firstlogin.component.html',
    styleUrls: ['./firstlogin.component.scss'],
    standalone: false
})
export class FirstloginComponent implements OnInit {
  isChromeBrowser: any;

  constructor(private router : Router , private _localstorage : LocalStorageService) { }

  ngOnInit() {
    let chromeid = localStorage.getItem('extensionID');
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'getSimilarCandidateResult' }, function (res) {
          if (res.similarCandidateData) {
            window.open(window.location.origin + '/talentpool', "_self")
          }
        });
      } catch (error) {
        console.error('Here is the error message', error);
      }
    }

    if(navigator.userAgent.indexOf("Chrome") != -1){
      this.isChromeBrowser = true
    }else{
      this.isChromeBrowser = false
    }
  }

  routeURL(type?){
    if(type){
      this.router.navigateByUrl('/search')
    }else{
      window.open('https://chrome.google.com/webstore/detail/webbtree-chrome-extension/jlmhleoipeloancgdilegcelojacmpcm?utm_source=gmail', "_blank")
    }
  }
}
